import { render } from "./publicTable.vue?vue&type=template&id=7b634eae"
import script from "./publicTable.vue?vue&type=script&lang=js"
export * from "./publicTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__